/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RecommendationSkuDetailsForAwsEndUserComputingWorkspace extends models.RecommendationSkuDetailsBase {
    constructor() {
        super();
        this.setDiscriminator("RecommendationSkuDetailsForAwsEndUserComputingWorkspace");
    }

    getFixupPrototypeFunction() { return RecommendationSkuDetailsForAwsEndUserComputingWorkspace.fixupPrototype; }

    static newInstance(model: Partial<RecommendationSkuDetailsForAwsEndUserComputingWorkspace>): RecommendationSkuDetailsForAwsEndUserComputingWorkspace {
        let obj = Object.assign(new RecommendationSkuDetailsForAwsEndUserComputingWorkspace(), model);
        RecommendationSkuDetailsForAwsEndUserComputingWorkspace.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RecommendationSkuDetailsForAwsEndUserComputingWorkspace>): RecommendationSkuDetailsForAwsEndUserComputingWorkspace {
        if (!model) return null;
        return RecommendationSkuDetailsForAwsEndUserComputingWorkspace.newInstance(<RecommendationSkuDetailsForAwsEndUserComputingWorkspace> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RecommendationSkuDetailsForAwsEndUserComputingWorkspace) {
        if (!obj) return;

        models.RecommendationSkuDetailsForAwsEndUserComputingWorkspace.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RecommendationSkuDetailsForAwsEndUserComputingWorkspace): boolean {
        if (models.RecommendationSkuDetailsBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, RecommendationSkuDetailsForAwsEndUserComputingWorkspace.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.root_volume === undefined) {
            this.root_volume = 0;
        }
        if (this.user_volume === undefined) {
            this.user_volume = 0;
        }
    }

    /**
     * Compute Type
     */
    compute_type_name: string;

    /**
     * Root Volume
     */
    root_volume: number;

    /**
     * User Volume
     */
    user_volume: number;

    /**
     * Running Mode
     */
    running_mode: string;

    /**
     * State
     */
    state: string;

}
